import { gql } from '@apollo/client';
import { CRM_CONTACT_FIELDS } from './queries';

export const CREATE_CRM_CONTACT = gql`
    mutation CreateCrmContact($input: CreateCrmContactInput!) {
        createCrmContact(input: $input) {
            ${CRM_CONTACT_FIELDS}
        }
    }
`;

export const UPDATE_CRM_CONTACT = gql`
    mutation UpdateCrmContact($input: UpdateCrmContactInput!) {
        updateCrmContact(input: $input) {
            ${CRM_CONTACT_FIELDS}
        }
    }
`;

export const ADD_CRM_CONTACT_NOTE = gql`
    mutation AddCrmContactNote($input: AddCrmContactNoteInput!) {
        addCrmContactNote(input: $input) {
            _id
            body
            authorId
            authorName
            isPinned
            createdAt
            updatedAt
        }
    }
`;

export const SET_CRM_CONTACT_NOTE_PINNED = gql`
    mutation SetCrmContactNotePinned($input: SetCrmContactNotePinnedInput!) {
        setCrmContactNotePinned(input: $input) {
            _id
            body
            authorId
            authorName
            isPinned
            createdAt
            updatedAt
        }
    }
`;

export const SET_PRIMARY_CRM_CONTACT = gql`
    mutation SetPrimaryCrmContact($contactId: String!) {
        setPrimaryCrmContact(contactId: $contactId) {
            ${CRM_CONTACT_FIELDS}
        }
    }
`;

export const SET_CRM_CONTACT_EMAIL_SUBSCRIBED = gql`
    mutation SetCrmContactEmailSubscribed($contactId: String!, $emailSubscribed: Boolean!) {
        setCrmContactEmailSubscribed(contactId: $contactId, emailSubscribed: $emailSubscribed) {
            ${CRM_CONTACT_FIELDS}
        }
    }
`;

export const DELETE_CRM_CONTACT = gql`
    mutation DeleteCrmContact($contactId: String!) {
        deleteCrmContact(contactId: $contactId) {
            _id
            accountId
        }
    }
`;
